import { render, staticRenderFns } from "./InvioEmailRecovery.vue?vue&type=template&id=438509a5&"
import script from "./InvioEmailRecovery.vue?vue&type=script&lang=js&"
export * from "./InvioEmailRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports